import { render, staticRenderFns } from "./OnboardingMatchingFavoriteActivitiesPage.vue?vue&type=template&id=3f5402e6&scoped=true&"
import script from "./OnboardingMatchingFavoriteActivitiesPage.vue?vue&type=script&lang=ts&"
export * from "./OnboardingMatchingFavoriteActivitiesPage.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingMatchingFavoriteActivitiesPage.vue?vue&type=style&index=0&id=3f5402e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5402e6",
  null
  
)

export default component.exports